// Klick-ausserhalb-schliesst für Overlays.
//
// Warum mousedown statt click: Ein click-Event feuert auf dem *gemeinsamen
// Vorfahren* von mousedown- und mouseup-Ziel. Markiert man Text in einem Input
// und lässt die Maustaste über dem abgedunkelten Rand los, ist dieser Vorfahre
// das Overlay selbst — `e.target === e.currentTarget` stimmt, und das Modal
// schliesst mitten in der Textauswahl. Für den Nutzer sieht das aus, als
// verlöre das Feld beim Markieren den Fokus.
// Mit mousedown zählt nur, wo der Klick *beginnt*.
export const overlayDismiss = (onClose) => ({
  onMouseDown: (e) => { if (e.target === e.currentTarget) onClose(); },
});

export default overlayDismiss;
